const ContractNote = () => import("./views/contract-note-upload.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/contract_note",
      component: ContractNote,
      name: "ContractNote",
      meta: {
        groupName: "Auction",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
